import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeleteOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"delete_outline"}/>
}
